import axios from "../../utils/axios";
import type {
    RiskAssessmentAiReplyDTO,
    RiskAssessmentScanReplyDTO,
    SendRiskAssessmentAiMessageRequest,
} from "../types/riskAssessmentAiDtos";

const apiUrl = process.env.REACT_APP_HS_API_URL;

const sendMessage = (request: SendRiskAssessmentAiMessageRequest) =>
    axios.post<RiskAssessmentAiReplyDTO>(`${apiUrl}/RiskAssessmentAi/Message`, request);

// The document is posted as multipart and never stored by SafetyNest - it is read
// to build the template and discarded, so there is no file id to hold on to.
const scanDocument = (file: File) => {
    const form = new FormData();
    form.append("file", file);

    return axios.post<RiskAssessmentScanReplyDTO>(`${apiUrl}/RiskAssessmentAi/Scan`, form);
};

const riskAssessmentAiService = {
    sendMessage,
    scanDocument,
};

export default riskAssessmentAiService;
